<template>
    <div id="pib-page">
        <!-- Header section -->
        <global-header v-bind:fontSize="fontSize"></global-header>

        <div id="content-section">
            <!-- Main section -->
            <main :aria-label="$t('main')">
                <category-info v-bind:categoryInfo="categoryInfo"></category-info>
                <div id="main">
                    <div class="container">
                        <div class="main-content">
                            <div class="row">
                                <div class="left-section col-xs-12 col-sm-12 col-md-6 d-flex flex-column bd-highlight mb-3 text-start">
                                    <h2 class="content-title" :style="'--category-color:' + categoryInfo.color" data-aos="show-from-bottom" data-aos-easing="from-bottom-easing" data-aos-delay="400">
                                        {{ $t('top-pib') }}
                                    </h2>
                                    <p
                                        class="text-white"
                                        data-aos="show-from-bottom"
                                        data-aos-anchor=".main-content"
                                        data-aos-easing="from-bottom-easing"
                                        data-aos-offset="50" data-aos-delay="500"
                                    >
                                        {{ $t('compare-pib') }}
                                    </p>
                                    <p
                                        class="text-white"
                                        data-aos="show-from-bottom"
                                        data-aos-anchor=".main-content"
                                        data-aos-easing="from-bottom-easing"
                                        data-aos-offset="50"
                                        data-aos-delay="500"
                                    >
                                        {{ $t('unit-pib') }}
                                    </p>
                                    <div class="radio-section mt-2 mb-2">
                                        <fieldset>
                                            <legend></legend>
                                            <radio-button
                                                data-aos="show-from-bottom"
                                                data-aos-easing="from-bottom-easing"
                                                data-aos-delay="600"
                                                data-aos-anchor=".main-content"
                                                data-aos-offset="50"
                                                data-aos-once="true"
                                                v-bind:name="categoryInfo.name"
                                                v-bind:options="radioOptions"
                                                v-on:changeOption="changeSelectedOption"
                                            >
                                            </radio-button>
                                        </fieldset>
                                    </div>
                                    <timeline-modal
                                        data-aos="show-from-bottom"
                                        data-aos-easing="from-bottom-easing"
                                        data-aos-anchor=".main-content"
                                        data-aos-delay="700"
                                        v-bind:categoryInfo="categoryInfo"
                                        v-bind:dates="dates"
                                        v-on:changeDates="changeSelectedDates"
                                        data-aos-once="true"
                                    >
                                    </timeline-modal>
                                    <div
                                        class="more-details mt-4 text-center text-xl-start"
                                        data-aos="show-from-bottom"
                                        data-aos-easing="from-bottom-easing"
                                        data-aos-anchor=".main-content"
                                        data-aos-delay="700"
                                        data-aos-offset="50"
                                        data-aos-once="true"
                                    >
                                        <p class="m-0" :style="'--category-color:' + categoryInfo.color">
                                            {{ categoryInfo.moreDetails }}
                                        </p>
                                    </div>
                                </div>
                                <div class="right-section col-xs-12 col-sm-12 col-md-6">
                                    <ranking
                                        v-bind:rankingData="rankingData"
                                        v-bind:categoryInfo="categoryInfo"
                                        v-bind:withModal="true"
                                        v-on:showModal="updateComparingData">
                                    </ranking>
                                    <source-button :content="$t('source')"></source-button>
                                </div>
                            </div>
                        </div>
                        <pib-modal
                            v-bind:categoryInfo="categoryInfo"
                            v-bind:comparingData="comparingData"
                            v-bind:dates="selectedDates"
                            v-bind:radioOptions="radioOptions"
                            v-bind:selectedRadioOption="selectedRadioOption"
                            v-on:changeOptionFromModal="changeSelectedOption"
                            v-bind:rankingData="modalRankingData"
                        >
                        </pib-modal>
                    </div>
                </div>
            </main>

            <!-- Footer section -->
            <hr class="footer-hr" :style="'--category-color:' + categoryInfo.color">
            <global-footer></global-footer>
        </div>
    </div>
</template>
<script>

// Import components
import SourceButton  from '../SourceButton.vue';
import Ranking       from '../Ranking.vue';
import RadioButton   from '../RadioButton.vue';
import TimelineModal from '../../layouts/TimelineModal.vue';
import PibModal      from '../comparisons/PibModal.vue';

// Import helpers
import { Default }  from '@/helpers/Default.js';

// Import Json data
import json from '/public/data.json';

export default {
    components: {
        SourceButton,
        Ranking,
        RadioButton,
        PibModal,
        TimelineModal
    },
    props: ['fontSize'],
    data () {
        return {
            dataJson:            json.pib,
            scrollPosition:      null,
            selectedRadioOption: null,
            selectedDates:       null,
            rankingData:         null,
            modalRankingData:    null,
            cloneDeep:           require('clone-deep'),
            categoryInfo: {
                name:        'pib',
                color:       Default.categories.pib.color,
                icon:        Default.categories.pib.icon,
                description: this.$i18n.t('timeline-info.pib.description'),
                moreDetails: this.$i18n.t('timeline-info.pib.more-info'),
                config:      {
                    'round'    : null,
                    'precision': null,
                    'prefix'   : null,
                    'suffix'   : null,
                    'decimal'  : null,
                    'thousand' : null,
                    'multiple' : null
                },
            },
            radioOptions: [],
            dates:        [],
            pibData:      {},
            dataOfCanada: {},
            comparingData: {
                canada: null,
                other:  null
            }
        };
    },
    watch: {
        selectedDates () {
            this.setRankingData(this.selectedDates, this.selectedRadioOption);
        },

        selectedRadioOption () {
            this.setRankingData(this.selectedDates, this.selectedRadioOption);
        },
    },
    mounted () {
        // Get the data
        this.getData();
        window.addEventListener('scroll', this.updateScroll);
    },
    methods: {
        /**
         * Get the data for the PIB category
         * 1- Get the options for the radio buttons
         * 2- Get the key dates.
         * 3- Get the global data.
         */
        getData () {
            this.dataJson.options.forEach(option => {
                this.radioOptions.push({
                    value: option, label: this.$i18n.t(option)
                });
            });

            this.dates   = this.dataJson.dates;
            this.pibData = this.dataJson.data;
        },

        /**
         * Define the data to display on the ranking.
         *
         * @param    {object}    dates     The period of the data
         * @param    {string}    option    The selected radio option
         */
        setRankingData (dates, option) {
            if (dates === null || option === null) {
                return;
            }

            this.rankingData         = this.pibData[option].find(data => (data.from === dates.from && data.to === dates.to)).data;
            this.modalRankingData    = this.cloneDeep(this.rankingData);
            this.dataOfCanada        = this.rankingData.find(data => (data.id === 'CA'));

            this.categoryInfo.config = this.$i18n.locale === 'fr' ?  {
                'round'    : 10,
                'precision': 0,
                'prefix'   : '',
                'suffix'   : ` ${this.$i18n.t(this.rankingData[0].type)}`,
                'decimal'  : ' ',
                'thousand' : ' ',
                'multiple' : null
            } : {
                'round'    : 10,
                'precision': 0,
                'prefix'   : '$',
                'suffix'   : this.selectedRadioOption === 'pib-total' ? this.$i18n.t(this.rankingData[0].type) : '',
                'decimal'  : '',
                'thousand' : ',',
                'multiple' : this.selectedRadioOption === 'pib-total' ? 1000000000 : null
            }
        },

        /**
         * Set the comparing country data with Canada and show modal.
         *
         * @param    {object}    country    the country to compare with Canada
         */
        updateComparingData (country) {
            // Stop body from scroll and keep scroll position
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollPosition}px`;

            this.comparingData.canada = this.cloneDeep(this.dataOfCanada);
            this.comparingData.other  = this.cloneDeep(country);

            this.comparingData.canada.rating = (this.comparingData.canada.value * 100) / (this.comparingData.canada.value + this.comparingData.other.value);
            this.comparingData.other.rating  = (this.comparingData.other.value * 100) / (this.comparingData.other.value + this.comparingData.canada.value);

            this.$bvModal.show(`${this.categoryInfo.name}-modal`);
        },

        /*
         * Set scroll position to save the position when modal open
         */
        updateScroll() {
            this.scrollPosition = window.scrollY;
        },

        /**
         * Change data with the new key dates.
         *
         * @param    {object}    dates    the new selected dates.
         */
        changeSelectedDates (dates) {
            this.selectedDates = dates;
        },

        /**
         * Change data with the new radio option.
         *
         * @param    {String}    option    the new selected option.
         */
        changeSelectedOption (option) {
            this.selectedRadioOption = option;
        }
    }
};
</script>
